import {NgModule} from '@angular/core';
import {CmsComponent} from './cms.component';
import {Routes, RouterModule} from '@angular/router';
import {EmployeeProfileGuard, OrdersGuard, ProjectGuard, SuperadminGuard} from '../_guards';
import {EmployeeGuard} from '../_guards';
import {AgencyGuard} from '../_guards';
import {ClientGuard} from '../_guards';
import {AgencyClientGuard} from '../_guards';
import {WorkValidationGuard} from '../_guards';
import {ClientWorkValidationGuard} from '../_guards';
import {InternalOnlyGuard} from '../_guards';
import {AuthGuard} from '../auth/controllers/auth.guard';
import { WorkValidationDetailsGuard } from 'app/_guards/work-validation-details.guard';
import { PayrollGuard } from 'app/_guards/payroll.guard';
import { SupervisorOnSiteGuard } from 'app/_guards/supervisor-on-site.guard';
import { OthersGuardGuard } from 'app/_guards/others-guard.guard';
import { AgencyProfileGuard } from 'app/_guards/agency-profile.guard';
import { SelfServiceGuard } from 'app/_guards/self-service.guard';
import { ClientLocationsGuard } from 'app/_guards/client-locations.guard';
// JS-1920 follow-up (2026-11-02): gate /agency-client/edit-templates on the new Edit
// Templates perm for client users; agency users pass through unchanged.
import { EditTemplatesGuard } from 'app/_guards/edit-templates.guard';
// JS-1920 follow-up (2026-11-03): gate /self-service/employees + /self-service/employees/:id
// on the new View Employee Profile perm for client users; agency users pass through.
import { ViewEmployeeProfileGuard } from 'app/_guards/view-employee-profile.guard';
// JS-1396: first guard of every shell route - nothing activates under the reopen lock.
import { ReopenLockGuard } from 'app/_guards/reopen-lock.guard';
// JS-1871: /client/locations needs its own guard (Self Service OR View Order).

const config = {
  apiKey: 'AIzaSyBM-5MzyZoh0hCJJtU0JrJCvcSbQR1f_44',
  authDomain: 'jobrocks-223208.firebaseapp.com',
  databaseURL: 'https://jobrocks-223208.firebaseio.com',
  projectId: 'jobrocks-223208',
  storageBucket: 'jobrocks-223208.appspot.com',
  messagingSenderId: '707476098256'
};
const routes: Routes = [
  {
    'path': 'project',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, ProjectGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/project\/dashboard\/dashboard.module#ProjectDashboardModule'
      },
      {
        'path': 'basic-info',
        'loadChildren': '.\/pages\/default\/project\/basic-information\/basic-information.module#BasicInformationModule'
      },
      {
        'path': 'basic-info/:id',
        'loadChildren': '.\/pages\/default\/project\/basic-information\/basic-information.module#BasicInformationModule'
      },
      {
        'path': 'project-planning/:id',
        'loadChildren': '.\/pages\/default\/project\/project-planning\/project-planning.module#ProjectPlanningModule'
      },
      {
        'path': 'ppc\/project-planning/:id',
        'loadChildren': '.\/pages\/default\/project\/pay-per-call\/project-planning\/project-planning.module#PPCProjectPlanningModule'
      },

      {
        'path': 'project-publishing/:id',
        'loadChildren': '.\/pages\/default\/project\/project-publishing\/project-publishing.module#ProjectPublishingModule'
      },
      {
        'path': 'staff-allocation/:id',
        'loadChildren': '.\/pages\/default\/project\/staff-allocation\/staff-allocation.module#StaffAllocationModule'
      },
      {
        'path': 'ppc\/staff-allocation/:id',
        'loadChildren': '.\/pages\/default\/project\/pay-per-call\/staff-allocation\/staff-allocation.module#PPCStaffAllocationModule'
      },
      // {
      //   'path': 'work-validation\/dashboard',
      //   'loadChildren':
      //     '.\/pages\/default\/project\/work-validation\/dashboard\/dashboard.module#DashboardModule'
      // },
      // {
      //   'path': 'work-validation\/details\/:id',
      //   'loadChildren':
      //     '.\/pages\/default\/project\/work-validation\/details\/details.module#DetailsModule'
      // },
      {
        'path': 'expenses-validation\/dashboard',
        'loadChildren':
          '.\/pages\/default\/project\/expenses-validation\/dashboard\/dashboard.module#DashboardModule'
      },
      {
        'path': 'expenses-validation\/details\/:id',
        'loadChildren':
          '.\/pages\/default\/project\/expenses-validation\/details\/details.module#DetailsModule'
      },
      {
        'path': 'project-staff/:id',
        'loadChildren': '.\/pages\/default\/project\/project-staff\/project-staff.module#ProjectStaffModule'
      },
      {
        'path': 'chat/:id',
        'loadChildren': '.\/pages\/default\/project\/project-chat\/chat.module#ChatModule'
      },
      {
        'path': 'import-planning',
        'loadChildren': '.\/pages\/default\/project\/import-planning\/import-planning.module#ImportPlanningModule',
        'canActivate': [InternalOnlyGuard],
      },
    ]
  },
  
  {
    'path': 'client-work-validation',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, ClientWorkValidationGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': 'dashboard',
        'loadChildren':
          '.\/pages\/default\/project\/client-work-validation\/dashboard\/dashboard.module#DashboardModule'
      },
      {
        'path': 'details\/:id',
        'loadChildren':
          '.\/pages\/default\/project\/client-work-validation\/details\/details.module#DetailsModule',
        'canActivate': [WorkValidationDetailsGuard],
      },
    ]
  },
  {
    'path': 'self-service',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, SelfServiceGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        // JS-1871 (Self Service 4a) — agency-side self-service projects dashboard.
        // Reuses the same component as the client's /self-service/projects.
        'path': 'dashboard',
        'loadChildren':
          '.\/pages\/default\/client\/self-service\/projects\/dashboard\/dashboard.module#SelfServiceProjectsDashboardModule'
      },
      {
        // JS-1871 (Self Service 4a) — client-side self-service projects dashboard.
        'path': 'projects',
        'loadChildren':
          '.\/pages\/default\/client\/self-service\/projects\/dashboard\/dashboard.module#SelfServiceProjectsDashboardModule'
      },
      {
        // JS-1871 (Self Service 4c) — reuse the agency basic-info/planning/publishing modules
        // under a self-service URL so the entire creation flow stays in /self-service/projects.
        'path': 'projects/basic-info',
        'loadChildren':
          '.\/pages\/default\/project\/basic-information\/basic-information.module#BasicInformationModule'
      },
      {
        'path': 'projects/basic-info/:id',
        'loadChildren':
          '.\/pages\/default\/project\/basic-information\/basic-information.module#BasicInformationModule'
      },
      {
        'path': 'projects/project-planning/:id',
        'loadChildren':
          '.\/pages\/default\/project\/project-planning\/project-planning.module#ProjectPlanningModule'
      },
      {
        'path': 'projects/project-publishing/:id',
        'loadChildren':
          '.\/pages\/default\/project\/project-publishing\/project-publishing.module#ProjectPublishingModule'
      },
      {
        'path': 'projects/staff-allocation/:id',
        'loadChildren':
          '.\/pages\/default\/project\/staff-allocation\/staff-allocation.module#StaffAllocationModule'
      },
      {
        // JS-1920 follow-up (2026-11-03): parent-route guard covers both /self-service/employees
        // (dashboard list) AND /self-service/employees/:id (per-employee profile) since Angular
        // runs parent canActivate before loading the lazy child modules — the ':id' child
        // reuses EmployeeProfileModule, which is also reachable from /profile/:id without this
        // guard (unaffected). Agency users pass through; the gate only trips on client users
        // without the "Client View Employee Profile" perm.
        'path': 'employees',
        'canActivate': [ViewEmployeeProfileGuard],
        'loadChildren':
          '.\/pages\/default\/client\/self-service\/employees\/self-service-employees.module#SelfServiceEmployeesModule'
      },
      // JS-1871: client locations moved out of /self-service/locations to /client/locations
      // (defined as a top-level route below) so users with View Order — not just Self Service —
      // can reach it. See ClientLocationsGuard for the widened permission check.
    ]
  },
  {
    'path': 'profile',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, EmployeeProfileGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/employee\/profile\/profile.module#EmployeeProfileModule'
      }
    ]
  },
  {
    'path': 'employee',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, EmployeeGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/employee\/dashboard\/dashboard.module#EmployeeDashboardModule'
      },
      {
        'path': 'profile/:id',
        'loadChildren': '.\/pages\/default\/employee\/profile\/profile.module#EmployeeProfileModule'
      },
      {
        'path': 'pinwall',
        'loadChildren': '.\/pages\/default\/employee\/dashboard\/dashboard.module#EmployeeDashboardModule'
      },
      {
        'path': 'filter',
        'loadChildren': '.\/pages\/default\/employee\/dashboard\/dashboard.module#EmployeeDashboardModule'
      },
      {
          // JS-2084: superadmin-only. Parent /employee gate (View All Employee Profiles)
          // is not enough — any role holding that perm would otherwise reach this.
          'path': 'superadmin',
          'canActivate': [SuperadminGuard],
          'loadChildren': '.\/pages\/default\/superadmin\/superadmin-dashboard\/superadmin-dashboard.module#SuperadminDashboardModule'
      },
      {
          // JS-2084: superadmin-only — same reason as /employee/superadmin above.
          'path': 'superadmin/profile/:id',
          'canActivate': [SuperadminGuard],
          'loadChildren': '.\/pages\/default\/superadmin\/profile\/profile.module#EmployeeProfileModule'
      },
      {
        'path': 'import-employees',
        'loadChildren': '.\/pages\/default\/agency\/import-employees\/import-employees.module#ImportEmployeesModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'import-job-histories',
        'loadChildren': '.\/pages\/default\/agency\/import-job-histories\/import-job-histories.module#ImportJobHistoriesModule',
        'canActivate': [AgencyGuard],
      },
    ]
  },
  {
    // JS-2084: superadmin-only. Previously ReopenLockGuard alone, so any logged-in
    // user (including clients) could reach EasyTemp — which lists agency API
    // credentials (api_user, api_password, mandant, api_url). SuperadminGuard mirrors
    // backend AccessGuard::isRole('superadmin').
    'path': 'superadmin/easytemp',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, SuperadminGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/superadmin\/easytemp\/easytemp.module#EasyTempModule'
      }
    ]
  },
  {
    'path': 'payroll',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, OthersGuardGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/others\/others.module#OthersModule'
      },
      {
        'path': 'payroll',
        'loadChildren': '.\/pages\/default\/agency\/payroll\/payroll.module#PayrollModule',
          canActivate: [PayrollGuard] 
      },
      {
        // JS-1901: payslip re-import + payslip PDF, split out of the payroll export screen
        'path': 'payslips',
        'loadChildren': '.\/pages\/default\/agency\/payslips\/payslips.module#PayslipsModule',
        canActivate: [PayrollGuard]
      },
      {
        'path': 'work-validation',
        'component': CmsComponent,
        'canActivate': [WorkValidationGuard],
        'children': [
          {
            'path': 'dashboard',
            'loadChildren':
              '.\/pages\/default\/project\/work-validation\/dashboard\/dashboard.module#DashboardModule'
          },
          {
            'path': 'details\/:id',
            'loadChildren':
              '.\/pages\/default\/project\/work-validation\/details\/details.module#DetailsModule',
            'canActivate': [WorkValidationDetailsGuard],
          },
          {
            'path': 'import-timestamps',
            'loadChildren':
              '.\/pages\/default\/project\/work-validation\/import-timestamps\/import-timestamps.module#ImportTimestampsModule',
            'canActivate': [InternalOnlyGuard],
          },
        ]
      },
    ]
  },
  {
    'path': 'mission-events',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, AuthGuard, InternalOnlyGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/employee\/event-store\/event-store.module#EventStoreModule',
      },
    ]
  },
  {
    'path': 'supervisor-on-site',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, SupervisorOnSiteGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': '',
        'loadChildren': '.\/pages\/default\/supervisor-on-site\/dashboard\/dashboard.module#TimestampSupervisorDashboardModule'
      },
      {
        'path': 'details/:id',
        'loadChildren': '.\/pages\/default\/supervisor-on-site\/details\/details.module#TimestampSupervisorDetailsdModule'
      },
    ]
  },
  {
    'path': 'agency',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': 'profile',
        'loadChildren': '.\/pages\/default\/agency\/profile\/profile.module#AgencyProfileModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'profile/:id',
        'loadChildren': '.\/pages\/default\/agency\/profile\/profile.module#AgencyProfileModule',
        'canActivate': [AgencyGuard, AgencyProfileGuard],
      },
      {
        'path': 'dashboard',
        'loadChildren': '.\/pages\/default\/agency\/dashboard\/dashboard.module#AgencyDashboardModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'admin\/profile',
        'loadChildren': '.\/pages\/default\/agency\/admin-profile\/profile.module#AgencyAdminProfileModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'credits/:id',
        'loadChildren': '.\/pages\/default\/agency\/credits\/credits.module#CreditsModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'edit-templates',
        'loadChildren': '.\/pages\/default\/agency\/edit-templates\/edit-templates.module#EditTemplatesModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'edit-clothing-requirements',
        'loadChildren': '.\/pages\/default\/agency\/edit-clothing-requirements\/edit-clothing-requirements.module#EditClothingRequirementsModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'sedcard',
        'loadChildren': '.\/pages\/default\/agency\/sedcard\/sedcard.module#SedcardModule',
        'canActivate': [AgencyGuard],
      },
      {
        path: 'sedcard/:id',
        loadChildren: './pages/default/agency/sedcard/sedcard.module#SedcardModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'work-report/:id',
        'loadChildren': '.\/pages\/default\/agency\/work-report\/work-report.module#WorkReportModule',
        'canActivate': [AgencyGuard],
      },
      {
        'path': 'employee-settings',
        'loadChildren': '.\/pages\/default\/agency\/employee-settings\/employee-settings.module#EmployeeSettingsModule',
        'canActivate': [AgencyGuard],
      },
    ]
  },
  {
    'path': 'agency-client',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, AgencyClientGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': 'profile/:id',
        'loadChildren': '.\/pages\/default\/client\/settings\/settings.module#SettingsModule'
      },
      {
        'path': 'edit-templates',
        // JS-1920 follow-up (2026-11-02): client users need the Edit Templates perm here;
        // agency users pass through regardless. See EditTemplatesGuard.
        'canActivate': [EditTemplatesGuard],
        'loadChildren': '.\/pages\/default\/agency\/edit-templates\/edit-templates.module#EditTemplatesModule'
      },
    ]
  },
  {
    'path': 'client',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, ClientGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': 'dashboard',
        'loadChildren': '.\/pages\/default\/client\/dashboard\/client-dashboard.module#ClientDashboardModule'
      },
      {
        'path': 'profile',
        'loadChildren': '.\/pages\/default\/client\/profile\/profile.module#ClientProfileModule'
      },
      {
        'path': 'profile/:id',
        'loadChildren': '.\/pages\/default\/client\/profile\/profile.module#ClientProfileModule'
      },
    ]
  },
  {
    // JS-1871: client locations lives at /client/locations (moved from /self-service/locations)
    // so View Order users can reach it too. Separate top-level route — ClientGuard requires
    // View Clients which doesn't fit, so this uses its own ClientLocationsGuard that permits
    // Self Service OR View Order.
    'path': 'client/locations',
    'component': CmsComponent,
    'canActivate': [ClientLocationsGuard],
    'children': [
      {
        'path': '',
        'loadChildren':
          '.\/pages\/default\/locations\/dashboard\/dashboard.module#LocationsDashboardModule'
      },
    ]
  },
  // {
  //   'path': 'client-dashboard',
  //   'component': CmsComponent,
  //   // 'canActivate': [AuthGuard],
  //   'children': [
  //     {
  //       'path': 'client-dashboard',
  //       'loadChildren': '.\/pages\/default\/client\/client-portal-dashboard\/client-portal-dashboard.module#ClientPortalDashboardModule'
  //     },
  //   ]
  // },

  // to be settled:

  {
    'path': '',
    'component': CmsComponent,
    'canActivate': [ReopenLockGuard, AuthGuard],
    'canActivateChild': [ReopenLockGuard],
    'children': [
      {
        'path': 'user',
        'loadChildren': '.\/pages\/default\/user\/profile\/profile.module#ProfileModule'
      },
      // JS-2084: disabled. Sidebar entry was already hidden (sidebarPermissions
      // hardcodes 'settings' => false) and the route only sat behind AuthGuard,
      // so any logged-in user could reach it by URL. Re-enable with a proper
      // role guard before uncommenting.
      // {
      //   'path': 'settings\/dashboard',
      //   'loadChildren': '.\/pages\/default\/settings\/dashboard\/dashboard.module#SettingsDashboardModule'
      // },
      {
        // JS-2084: locations is agency staff only. Previously AuthGuard-only, so clients
        // could read every agency's locations with coords via direct URL. InternalOnlyGuard
        // blocks any role containing 'client' or 'employee'.
        'path': 'locations\/dashboard',
        'canActivate': [InternalOnlyGuard],
        'loadChildren': '.\/pages\/default\/locations\/dashboard\/dashboard.module#LocationsDashboardModule'
      },
      // JS-2084: disabled. Agency-scoped translation editor with write access,
      // reachable by any logged-in user (AuthGuard only). Re-enable with a proper
      // role guard before uncommenting.
      // {
      //   'path': 'agency\/translates/:id',
      //   'loadChildren': '.\/pages\/default\/agency\/translates\/translate.module#AgencyTranslateModule'
      // },
      // JS-2084: disabled. Platform-wide translation table with write access,
      // reachable by any logged-in user (AuthGuard only). Re-enable with an
      // InternalOnlyGuard (or stricter) before uncommenting.
      // {
      //   'path': 'translate',
      //   'loadChildren': '.\/pages\/default\/translate\/translate-table.module#TranslateTableModule'
      // },
      {
        'path': 'not-found',
        'loadChildren': '.\/pages\/self-layout\/self-layout.module#SelfLayoutModule'
      },
      {
        'path': 'client-settings',
        'loadChildren': '.\/pages\/default\/client\/settings\/settings.module#SettingsModule'
      },
      {
        // JS-2084: /orders is the client-facing orders list. It now uses OrdersGuard
        // (backend branch 'orders' → View Order) so ProjectGuard can stay strictly
        // agency-only and clients can no longer reach /project/* via View Order.
        'path': 'orders',
        'canActivate': [OrdersGuard],
        'loadChildren': '.\/pages\/default\/client\/orders\/orders.module#OrdersModule'
      },
      {
        'path': 'client-dashboard',
        'loadChildren': '.\/pages\/default\/client\/client-portal-dashboard\/client-portal-dashboard.module#ClientPortalDashboardModule'
      },
      {
        'path': 'staff',
        'loadChildren': '.\/pages\/default\/client\/staff\/staff.module#StaffModule'
      },
    ]
  },
  {
    'path': '**',
    'redirectTo': '',
    'pathMatch': 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    // AngularFireModule.initializeApp(config),
  ],
  exports: [RouterModule]
})
export class CmsRoutingModule {
}
